<template>
  <v-alert outlined text type="error" v-if="message">
    <div class="title">
      {{ fixedMessage }}
    </div>
    <div style="white-space: pre-line">
      {{ message }}
    </div>
    <br />
    <template v-if="details">
      <div class="subtitle-2" v-for="(detail, key) in details" :key="key">
        {{ detail }}
      </div>
      <br />
    </template>
    <div style="white-space: pre-line">
      {{ todoMessage }}
    </div>
  </v-alert>
</template>
<script>
import {
  ErrorTodoMessages,
  ErrorTodoMessagesForFront
} from "@/js/constants/error-messages";

export default {
  name: "ErrorMessage",
  data: () => ({
    message: "",
    details: "",
    todoMessage: "",
    fixedMessage: ErrorTodoMessages.ERWE40021
  }),

  watch: {
    $route: "initialize",
    errorObject: "initialize"
  },
  props: {
    errorObject: {
      type: Object,
      required: false,
      default: undefined
    },
    errorScreenId: {
      type: String,
      required: false,
      defaut: undefined
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.$route.params && this.$route.params.error) {
        let error = this.$route.params.error;
        this.setError(error);
      } else if (this.errorObject && this.errorObject.error) {
        let error = this.errorObject.error;
        this.setError(error);
      } else if (this.$route.params.cancel) {
        this.fixedMessage = "";
        this.message = this.$route.params.cancel.message;
      } else {
        this.message = "";
        this.details = "";
      }
    },
    setError(error) {
      this.message = "";
      this.details = "";
      if (error.message && error.message.value) {
        this.message = error.message.value;
      }
      // APIエラーレスポンスに詳細情報が存在する場合
      if (error.message.details) {
        this.details = error.message.details;
      }
      // エラーメッセージ出し分け処理（エラーコードがERAE40004のときのみ）
      if (error.code === "ERAE40004") {
        // 仮QRコード・学校QRコード発行単位登録画面の時（画面IDで出し分け判定）
        if (this.errorScreenId) {
          this.todoMessage = ErrorTodoMessagesForFront[error.code](
            this.errorScreenId
          );
        } else {
          // 仮QRコード・学校QRコード発行単位登録画面以外は空で返す
          this.todoMessage = "";
        }
      } else {
        // 画面特有のエラーメッセージがある場合
        if (ErrorTodoMessagesForFront[error.code]) {
          this.todoMessage = ErrorTodoMessagesForFront[error.code];
        } else {
          // 画面特有のエラーメッセージがない場合は空で返す
          this.todoMessage = "";
        }
      }
    }
  }
};
</script>
